import { Box } from 'reflexbox';
import styled from 'styled-components';

import { useViewer } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import { Skeleton } from '@treams/treams-ui';

import { ContextSidebar } from '../../context-sidebar';

const SidebarContainer = styled(Box)`
	height: 100%;
	overflow: auto;
`;

const EvaluationSubmissionSidebar = Skeleton(
	function EvaluationSubmissionSidebar(props: {
		onClose?: () => void;
		user: graphql.User;
		conversationID: string;
	}) {
		const viewer = useViewer();

		const query = graphql.useEvaluationSubmissionQuery({ variables: { id: props.conversationID } });

		const employeeID = query.data?.evaluationSubmission.employee.user.id;
		const managerID = query.data?.evaluationSubmission.manager.user.id;
		const viewerID = viewer?.id;

		const isEmployee = viewerID === employeeID;
		const otherUserID = isEmployee ? managerID : employeeID;
		const viewerIsConversationParticipant =
			Boolean(viewerID) && (viewerID === employeeID || viewerID === managerID);

		return (
			<ContextSidebar
				onClose={props.onClose}
				user={props.user}
				currentConversationID={props.conversationID}
				otherUserID={otherUserID}
				viewerIsConversationParticipant={viewerIsConversationParticipant}
			/>
		);
	},
	function EvaluationSubmissionSidebarSkeleton() {
		return <SidebarContainer />;
	},
);

export default EvaluationSubmissionSidebar;
